<template>
  <div class="box">
    <div class="box_title_add">
      <span>演出日期</span>
      <img src="@/assets/xxx.png" alt="" @click="close">
    </div>
    <div style="margin-top:2rem;">
      <el-table
            :data="tableData"
            :header-cell-style="tableHeaderColor"
            :cell-style="cellStyle"
            style="width: 100%"
            ref="multipleTable"
          >
            <el-table-column label="场次时间" prop="movie_name">
              <template slot-scope="scope">
                {{scope.row.time}}
              </template>
            </el-table-column>
            <el-table-column label="演出时间" prop="movie_name">
              <template slot-scope="scope">
                {{scope.row.start_time}} - {{scope.row.end_time}}
              </template>
            </el-table-column>
            <el-table-column label="营业区域" prop="movie_area_names"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                  <div class="operation">
                    <div class="add_bianji" @click="openDialog(scope.row)">日期设置</div>
                  </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- <div class="pagination">
            <span class="totla">排序规则遵循降序规则，数据按照从大到小的顺序排列，数据越大内容越往前，新填加的内容系统默认排序为0</span>
            <span class="demonstration">共{{total}}条记录，</span>
            <span class="demonstration">当前显示第{{data.page}}页</span>
            <el-pagination background layout="prev, pager, next" :page-size="data.page_size" :total="total" ></el-pagination>
          </div> -->
    </div>
    <el-dialog :close-on-click-modal="false"
      title="日期设置"
      :visible.sync="addFlow"
      :before-close="addProHandleClose"
      width="600px"
      center
    >
        <div class="restaurant">
          <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-form-item label="演出时间：" required>
                <div class="flex_time">
                  <el-date-picker
                    v-model="form.start"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                  <span>至</span>
                  <el-date-picker
                    v-model="form.end"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </div>
            </el-form-item>
            <el-form-item label="预售时间：" prop="input">
              <div class="flex_date_input">
                <div>
                  <el-input v-model="form.input" placeholder="请输入"></el-input>
                  <span>天</span>
                </div>
                <div>
                  注：是指在购买演出票时，展示购买天数。（例:“设置2，只展示2天的票”）
                </div>                         
              </div>
            </el-form-item>
            <el-form-item label="销售模式：" required>
              <el-radio-group v-model="form.radio">
                <el-radio label="1">每日</el-radio>
                <el-radio label="2">
                  <template>
                    <div class="zdyBtns" @click="zdyiClick">
                      自定义
                    </div>
                  </template>
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <div class="date_button">
            <div @click="btns">确认保存</div>
          </div>
        </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"
      title="模式自定义"
      :visible.sync="temp"
      :before-close="tempClose"
      width="1500px"
      center
    >
        <div class="restaurant">
          <el-radio-group v-model="form.type" @change="zdyRadio">
              <el-radio label="1">批量设置</el-radio>
              <el-radio label="2">指定日期设置</el-radio>
          </el-radio-group>
          <div class="template_boxs" v-if="form.type==1" v-for="(item,index) in movie_all_showtimes">
            <div>
              <span>日期选择：</span>
              <el-checkbox-group v-model="item.week" @change="handleCheckedCitiesChange">
                  <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
              </el-checkbox-group>
              <div class="flex_end" v-if="index>0" @click="deteleShow(index)">
                <img src="@/assets/detele.png" alt="">
                <span>删除</span>
              </div>
            </div>
            <div>
              <span>价格设定：</span>
              <el-radio-group v-model="item.price_set">
                  <el-radio label="1">原价</el-radio>
                  <el-radio label="2">增幅</el-radio>
              </el-radio-group>
              <el-input v-model="item.pct" placeholder="请输入"></el-input>
              <span>%</span>
            </div>
          </div>
          <div class="add_btns"  @click="addshowTimes" v-if="form.type==1"> 
            <div>
              添加
            </div>
          </div>
          <div class="date_box" v-if="form.type==2">
            <div class="btnHer">
              <div class="her" @click="getPreMonth" >
                上一个月
              </div>
              <div class="her" @click="getGoMonth" >
                下一个月
              </div>
            </div>
            <el-calendar v-model="value">
              <div slot="dateCell" slot-scope="{date, data}" >
                <p
                  :class="data.isSelected ? 'is-selected' : ''"
                 >{{ data.day }} </p>
                <div v-for="(item,index) in dateList" :key="index" class="dateList_box" v-if="data.day==item.date">
                  <el-radio-group v-model="item.price_set">
                      <el-radio  label="1">原价</el-radio>
                      <div class="list_box_flex">
                        <el-radio label="2">增幅</el-radio>
                        <el-input v-model="item.pct" placeholder="请输入"></el-input>
                        <p>%</p>
                      </div>
                      <div class="list_btns" :class="item.status==2?'reds':''" @click="statusClick(item)">
                        {{item.status=='1'?"上架":'下架'}}
                      </div>
                  </el-radio-group>
                </div>
              </div>
          </el-calendar>
          </div>
          <div class="date_button">
            <div @click="date_Click">确认</div>
          </div>
        </div>
    </el-dialog>
  </div>
</template>
<script>
const cityOptions = [
  "星期一",
  "星期二",
  "星期三",
  "星期四",
  "星期五",
  "星期六",
  "星期日"
];
import { getmMvieShowtimes , setMoiveDate , getMovieAloneShowtimes , setMoiveDateInfo } from '@/request/scenic.js'
import { Message } from 'element-ui'
export default {
  data(){
    return{
      checkedCities: ['星期一','星期二','星期三','星期四','星期五','星期六','星期日',],
      form:{
        start:'',
        end:'',
        input:'',
        radio:1,
        id:'',
        time:'',
        type:1,
        token:window.sessionStorage.getItem('Token'),
      },
      rules: {
        input: [{ required: true, message: '请输入预售时间', trigger: 'blur' }],
      },
      tableData:[],
      multipleSelection:[],
      total:0,
      addFlow:false,
      temp:false,
      isIndeterminate:true,
      cities: cityOptions,
      dateList:[],
      value:new Date(),
      data:{},
      movie_all_showtimes:[
        {
          time:'',
          price_set:'1',
          pct:'',
          week:[],
          status:'1'
        }
      ],
      row:''
    }
  },
  created(){
    this.getList()
  },
  methods:{
    statusClick(item){
      if(item.status==1){
        item.status=2
      }else{
        item.status=1
      }
    },
    deteleShow(index){
      this.movie_all_showtimes.splice(index,1)
    },
    addshowTimes(){
      this.movie_all_showtimes.push({
          time:this.form.time,
          price_set:'1',
          pct:'',
          week:[],
          status:'1'
      })
    },
     // 点击获取上个月
     getPreMonth() {
      let date = this.getTime(this.value)
      var arr = date.split('-');
      var year = arr[0]; //获取当前日期的年份
      var month = arr[1]; //获取当前日期的月份
      var day = arr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中月的天数
      var year2 = year;
      var month2 = parseInt(month) - 1;
      if (month2 == 0) {
          year2 = parseInt(year2) - 1;
          month2 = 12;
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
          day2 = days2;
      }
      if (month2 < 10) {
          month2 = '0' + month2;
      }
      var t2 = year2 + '-' + month2 + '-' + day2;
      this.value = new Date(t2)
      this.dateList = []
      this.allcalendar(t2)
    },
    getGoMonth(){
      let date = this.getTime(this.value)
      var arr = date.split('-');
      var year = arr[0]; //获取当前日期的年份
      var month = arr[1]; //获取当前日期的月份
      var day = arr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中的月的天数
      var year2 = year;
      var month2 = parseInt(month) + 1;
      if (month2 == 13) {
          year2 = parseInt(year2) + 1;
          month2 = 1;
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
          day2 = days2;
      }
      if (month2 < 10) {
          month2 = '0' + month2;
      }
      var t2 = year2 + '-' + month2 + '-' + day2;
      this.value = new Date(t2)
      this.dateList = []
      this.allcalendar(t2)
    },
    allcalendar(e){
      var date = new Date(e);
      let firstDay =  this.getStartTime(e)
      let lastDay = this.getEndTime(e)
      var year = date.getFullYear(); // 年
      var month = date.getMonth() + 1; // 月
      var first = year + '-' + (month<10?'0'+month:month) + '-' + firstDay
      var last = year + '-' + (month<10?'0'+month:month)  + '-' + lastDay 
      let data = {
        token:window.sessionStorage.getItem('Token'),
        movie_id:this.row.movie_id,
        time:this.form.time,
        start_time:first,
        end_time:last
      }
      getMovieAloneShowtimes(data).then(res=>{
        if(res.data.status=='ok'){
          this.dateList = res.data.result
          this.dateList.map(item=>{
            item.price_set += ''
            item.status = item.status
            if(item.price_set==1){
              item.pct = ''
            }
          })
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    zdyRadio(e){
      if(this.form.start==''){
        Message.error('请选择演出开始时间')
        return false
      }
      if(this.form.end==''){
        Message.error('请选择演出结束时间')
        return false
      }
      if(this.form.input==''){
        Message.error('请输入预售时间')
        return false
      }
      if(e==2){
        let data = {
          token:window.sessionStorage.getItem('Token'),
          movie_id:this.row.movie_id,
          time:this.form.time,
          start_time:this.getCurrentMonthFirst(),
          end_time:this.getLastDay()
        }
        getMovieAloneShowtimes(data).then(res=>{
          if(res.data.status=='ok'){
            this.dateList = res.data.result
            this.dateList.map(item=>{
              item.price_set += ''
              item.status = item.status
              if(item.price_set==1){
                item.pct = ''
              }
            })
          }else{
            Message.error(res.data.msg)
          }
        })
      }
    },
     // 最后一天
    getLastDay(e){
        if(e){
          var dateObj = new Date(e)
        }else{
          var dateObj = new Date()
        }
        var y = dateObj.getFullYear(); //获取年份
        var m = dateObj.getMonth() + 1; //获取月份
        var d = new Date(y, m, 0).getDate(); //获取当月最后一日
        m = m < 10 ? '0' + m : m; //月份补 0
        d = d < 10 ? '0' + d : d; //日数补 0
        return [y,m,d].join("-")
    },   
    // 第一天
    getCurrentMonthFirst(){
        var dateObj = new Date()
        var y = dateObj.getFullYear(); //获取年份
        var m = dateObj.getMonth() + 1; //获取月份
        var d = '01';
        m = m < 10 ? '0' + m : m; //月份补 0
        return [y,m,d].join("-")
    },
    date_Click(){
      if(this.form.type=='1'){
        this.movie_all_showtimes.map(item=>{
          let weekString = ''
          item.week.map(itm=>{
            switch(itm){
              case '星期一':
                weekString += 1 +','
                    break;
                case '星期二':
                weekString += 2 +','
                    break;
                case '星期三':
                weekString += 3 +','
                    break;
                case '星期四':
                weekString += 4 +','
                    break;
                case '星期五':
                weekString += 5 +','
                    break;
                case '星期六':
                weekString += 6 +','
                    break;
                case '星期日':
                weekString += 7 +','
                    break;
                default:
                    break;
            }
          })
          let option = weekString.slice(0,-1)
          item.time = this.form.time
          item.week = option
        })
        this.form.movie_all_showtimes = this.movie_all_showtimes
        let data = {
          token:window.sessionStorage.getItem('Token'),
          start_time:this.form.start,
          end_time:this.form.end,
          presell_day:this.form.input,
          sell_type:this.form.radio,
          id:this.form.id,
          time:this.form.time,
          movie_all_showtimes:this.form.movie_all_showtimes,
          type:this.form.type
        }
        setMoiveDate(data).then(res=>{
          if(res.data.status=='ok'){
            this.getList()
            Message.success('日期批量设置成功')
            this.addFlow = false
            this.temp = false
          }else{
            Message.error(res.data.msg)
          }
        })
      }else{
        let movie_alone_showtimes = []
        this.dateList.map(item=>{
          movie_alone_showtimes.push({
            time:this.form.time,
            day:item.date,
            price_set:item.price_set,
            pct:item.pct,
            status:item.status
          })
        })
        this.form.movie_all_showtimes =  []
        let data = {
          token:window.sessionStorage.getItem('Token'),
          start_time:this.form.start,
          end_time:this.form.end,
          presell_day:this.form.input,
          sell_type:this.form.radio,
          id:this.form.id,
          time:this.form.time,
          movie_all_showtimes:this.form.movie_all_showtimes,
          type:this.form.type,
          movie_alone_showtimes:movie_alone_showtimes
        }
        setMoiveDate(data).then(res=>{
          if(res.data.status=='ok'){
            this.getList()
            Message.success('日期批量设置成功')
            this.addFlow = false
            this.temp = false
          }else{
            Message.error(res.data.msg)
          }
        })
      }
      
    },
    zdyiClick(){
      if(this.form.start==''||!this.form.start){
        Message.error('请设置演出开始时间')
        return false
      }
      if(this.form.end==''||!this.form.end){
        Message.error('请设置演出结束时间')
        return false
      }
      if(!this.form.input){
        Message.error('请输入预售时间')
        return false
      }
      this.temp = true
    },
    btns(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        start_time:this.form.start,
        end_time:this.form.end,
        presell_day:this.form.input,
        sell_type:this.form.radio,
        id:this.form.id,
        time:this.form.time
      }
      setMoiveDate(data).then(res=>{
        if(res.data.status=='ok'){
          this.getList()
          Message.success('日期设置成功')
          this.addFlow = false
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    getList(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        id:this.$route.query.id
      }
      getmMvieShowtimes(data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result
        }
      })
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    tempClose(){
      this.temp = false
    },
    addProHandleClose(){
      this.addFlow = false
    },
    openDialog(row){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        time:row.time,
        movie_id:row.movie_id
      }
      setMoiveDateInfo(data).then(res=>{
        if(res.data.status=='ok'){
          this.row = row
          this.form={
            token:window.sessionStorage.getItem('Token'),
            start:res.data.result.start_time,
            end:res.data.result.end_time,
            input:res.data.result.presell_day,
            radio:res.data.result.sell_type + '',
            time:res.data.result.time,
            id:row.movie_id,
            type:'1'
          }
          this.value = new Date()
          this.$forceUpdate()
          if(this.form.radio==2){
            this.temp = true
            this.movie_all_showtimes = []
            if(res.data.result.all_showtimes.length!=0){
              res.data.result.all_showtimes.map(item=>{
                var arr = []
                if(item.week.split(',').length!=0){
                  item.week.split(',').map(item=>{
                    switch(item){
                      case '1':
                      arr.push('星期一')
                          break;
                      case '2':
                      arr.push('星期二')
                          break;
                      case '3':
                      arr.push('星期三')
                          break;
                      case '4':
                      arr.push('星期四')
                          break;
                      case '5':
                      arr.push('星期五')
                          break;
                      case '6':
                      arr.push('星期六')
                          break;
                      case '7':
                      arr.push('星期日')
                          break;
                      default:
                          break;
                    }
                  })
                }
                this.movie_all_showtimes.push({
                  time:row.time,
                  price_set:item.price_set + '',
                  pct:item.pct,
                  week:arr  
                })
              })
            }
          }
        }else{
          this.form.id=row.movie_id
          this.form.type = '1'
          this.form.radio = '1'
          this.form.time = row.time
        }
      })
      this.addFlow = true
    },
    handleSelect(val){
      this.multipleSelection = []
      this.multipleSelection = val
    },
    close(){
      this.$router.go(-1)
    },
     // 表头设置
     tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    },
    getTime(date){
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      let d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      let h =date.getHours()
      h = h < 10 ? ('0' + h) : h
      let M =date.getMinutes()
      M = M < 10 ? ('0' + M) : M
      let s =date.getSeconds()
      s = s < 10 ? ('0' + s) : s
      return y + '-' + m + '-' + d 
      // + ' ' + h + ':' + M + ':' + s;
    },
    // 第一天
    getStartTime(e) {
        let date = new Date(e)
        date.setDate(1) // 将当前时间的日期设置成第一天
        let year= date.getFullYear()  // 得到当前年份 
        let month = date.getMonth()  + 1 // 得到当前月份（0-11月份，+1是当前月份）
        month  = month > 10 ? month :'0' + month // 补零
        let day  = date.getDate() // 得到当前天数，实际是本月第一天，因为前面setDate(1) 设置过了
        return  (day<10?'0'+day:day)// 这里传入的是字符串
    },
    // 最后一天
    getEndTime(e){
      let  date  = new Date(e)
      let year = date.getFullYear()  
      let month = date.getMonth() +1
    // 这里传入的是整数时间，返回的是下个月的第一天，因为月份是0-11
      let nextMonthFirthDay = new Date(year,month,1) // 下个月的第一天
      console.log(nextMonthFirthDay)
      let oneDay = 1000*60 * 60 * 24 // 一天的时间毫秒数
      let endDay = new Date(nextMonthFirthDay - oneDay) 
      let day = endDay.getDate() // 本月最后一天
      // 这里传入的是字符串格式的时间，返回的是传入字符串的时间
      return (day<10?'0'+day:day)
    },
  }
}
</script>
<style lang="less" scoped>
.template_boxs{
  width: 100%;
  padding: 3rem 1.2rem;
  box-sizing: border-box;
  border: 1px solid #E5E5EA;
  margin-bottom: 4rem;
  >div{
    display: flex;
    align-items: center;
    &:nth-child(1){
      margin-bottom: 3rem;
      >span{
        color: #666;
      }
      .flex_end{
        display: flex;
        align-items: center;
        cursor: pointer;
        margin-left: auto;
        img{
          width: 1.4rem;
          height: 1.5rem;
        }
        span{
          color: #FF4D4F;
        }
      }
    }
    &:nth-child(2){
      ::v-deep .el-input{
        width: 10rem;
        margin-left: 1rem;
      }
      >span{
        color: #FF4D4F;
        font-size: 1.4rem;
        &:nth-child(1){
          color: #666666;
        }
        &:nth-child(4){
          color: #666666;
          display: block;
          margin-left: 1rem;
        }
        &:nth-child(5){
          margin-left: 2rem;
          display: block;
        }
      }
    }
  }
}
.date_box{
  margin-bottom: 4rem;
  /deep/thead {
    th {
      margin-right: 10px;
      text-align: center !important;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
      background: #246deb;
      border-radius: 4px 4px 0px 0px;
    }
  }
  /deep/.el-calendar-table{
    >thead{
      >th:nth-of-type(6){
        background: #4ECB73;
      }
      >th:nth-of-type(7){
        background: #4ECB73;
      }
    }
  }
  /deep/.el-calendar-table__row{
    >td:nth-of-type(6){
      .el-calendar-day{
        border-top: 3px solid #4ECB73;
        // border-bottom: 3px solid #4ECB73;
      }
    }
    >td:nth-of-type(7){
      .el-calendar-day{
        border-top: 3px solid #4ECB73;
        // border-bottom: 3px solid #4ECB73;
      }
    }
  }
  /deep/.el-calendar-day {
    box-sizing: border-box;
    padding: 10px 0;
    height: 18.3rem;
    width: 20rem;
    background: #eaf1fd;
    border-top: 3px solid #87aff4;
  }
  tbody {
  p {
      width: 198px;
      text-align: center;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      color: #909090;
    }
  }
}
.add_btns{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 4rem;
  div{
    width: 10rem;
    height: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #246DEB;
    color: #246DEB;
    border-radius: 0.4rem;
    cursor: pointer;
  }
}
.box_title_add{
  padding: 1.8rem 0;
  box-sizing: border-box;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #E5E5EA;
  >span{
    color: #000000;
    font-size: 2rem;
    font-weight: 600;
  }
  img{
    position: absolute;
    right: 2rem;
    top: 40%;
    transform: translate(-50%,0);
    cursor: pointer;
    width: 1.8rem;
    height: 1.8rem;
  }
}
.box{
  padding: 0 2rem;
  height: 100%;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  flex-direction: column;
}
.add_bianji{
  color: #246DEB;
  font-size: 1.4rem;
  margin-right: 2rem;
  cursor: pointer;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
  .totla{
    position: absolute;
    left: 2rem;
    width: 35rem;
    color: red !important;
  }
}
::v-deep .el-dialog__body{
  padding: 0 !important;
  border-top: 1px solid #E5E5EA;
}
::v-deep .el-dialog__close {
  font-size: 2.5rem;
  color: #333333 !important;
}
.restaurant{
  padding: 2rem;
  box-sizing: border-box;
}
.flex_time{
  display: flex;
  align-items: center;
  >span{
    color: #666666;
    display: block;
    margin: 0 1.3rem;
  }
  ::v-deep .el-date-editor{
    width: 20rem;
  }
}
.flex_date_input{
  display: flex;
  >div{
    &:nth-child(1){
      display: flex;
      ::v-deep .el-input{
        width: 15rem;
      }
      >span{
        color: #666666;
        font-size: 1.4rem;
        margin-left: 1rem;
      }
    }
    &:nth-child(2){
      color: #FF4D4F;
      font-size: 1.4rem;
      margin-left: 2rem;
      line-height: 1.8rem;
    }
  }
}
::v-deep .el-radio-group{
  display: flex;
  align-items: center;
  height: 4rem;
}
.zdyBtns{
  width: 10rem;
  height: 4rem;
  border-radius: 0.4rem;
  border: 1px solid #246DEB;
  color: #246DEB;
  font-size: 1.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.date_button{
  display: flex;
  justify-content: center;
  align-items: center;
  div{
    width: 10rem;
    height: 4rem;
    border-radius: 0.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
      background: #246DEB;
      margin-left: 2rem;
  }
}
::v-deep .el-radio{
  display: flex;
  align-items: center;
}
.dateList_box{
  padding: 0 2rem;
  box-sizing: border-box;
  ::v-deep .el-radio-group{
    display: flex;
    flex-direction: column;
    align-items: baseline;
    .el-input{
      width: 8rem;
    }
    .list_box_flex{
      display: flex;
      align-items: center;
      margin-top: 1.5rem;
      .el-radio{
        margin-right: 1rem;
      }
      p{
        width: 0;
        margin-top:1.5rem;
        font-size: 1.4rem;
        margin-left: 0.5rem;
      }
    }
  }
}
/deep/ .el-calendar__header{
  display: none;
}
::v-deep .el-calendar-table:not(.is-range) td.next {
  display: none;
}
.btnHer{
  display: flex;
  justify-content: end;
  .her{
    width: 10rem;
    height: 4rem;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right:1.5rem;
    cursor: pointer;
}
}
.list_btns{
  width: 100%;
  padding: 0.6rem 0;
  box-sizing: border-box;
  margin-top:1rem;
  border-radius: 0.4rem;
  border: 2px solid #246DEB;
  font-size: 1.4rem;
  color: #246DEB;
  display: flex;
  justify-content: center;
  align-items: center;
}
.reds{
  color: red;
  border-color: red;
}

</style>